import { FetchHelper } from "shared-ts-utils-fetch";
import { WebPushRegistrationDto } from "./WebPushRegistrationDto";
import { UserSubscriptionsDto } from "./UserSubscriptions";

export class PushNotificationDao {
  private readonly fetchHelper: FetchHelper;

  constructor() {
    this.fetchHelper = new FetchHelper({ basePath: "/api/push-notifications" });
  }

  public getSubscriptions(): Promise<UserSubscriptionsDto> {
    return this.fetchHelper.get("/subscriptions").fetchAsJson();
  }

  public subscribeToWebNotifications(
    registration: WebPushRegistrationDto
  ): Promise<void> {
    return this.fetchHelper.post("/web/subscribe", registration).fetch();
  }

  public unsubscribeFromWebNotifications(
    subscriptionId: string
  ): Promise<void> {
    return this.fetchHelper.delete(`/subscriptions/${subscriptionId}`).fetch();
  }
}
